import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Skel } from "@/components/app/Common";
import { api, get, errMsg } from "@/lib/api";

const T = [["strongly_recommend", "Strongly recommend at or above"], ["recommend", "Recommend at or above"], ["consider", "Consider at or above"]];

export default function FitDefaults() {
  const { data, isLoading } = useQuery({ queryKey: ["fit-defaults"], queryFn: () => get("/settings/fit-defaults") });
  const [th, setTh] = useState(null);
  useEffect(() => { if (data) setTh(data); }, [data]);
  if (isLoading || !th) return <Skel className="h-48" />;
  const save = async () => { try { await api.put("/settings/fit-defaults", Object.fromEntries(T.map(([k]) => [k, Number(th[k])]))); toast.success("Defaults saved. Jobs without custom thresholds recalculate in the background."); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <section className="panel max-w-xl space-y-4 p-6" data-testid="fit-defaults-page">
      <div><h2 className="text-lg font-semibold">Fit Score recommendations</h2><p className="text-sm text-ink-secondary">Organisation defaults. Each job can set its own thresholds in its Final ranking tab.</p></div>
      {T.map(([k, l]) => <div key={k} className="flex items-center justify-between text-sm"><span className="text-ink-secondary">{l}</span>
        <input type="number" step={0.1} min={0} max={10} value={th[k]} onChange={(e) => setTh({ ...th, [k]: e.target.value })} className="h-9 w-24 rounded-lg border border-line px-2 text-right tabular-nums" data-testid={`default-threshold-${k}`} /></div>)}
      <p className="text-xs text-ink-muted">Below the Consider line is “Not recommended”. It never rejects anyone automatically.</p>
      <Button onClick={save} data-testid="fit-defaults-save">Save defaults</Button>
    </section>
  );
}
